if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();

        this.loadingOverlay = this.querySelector('[id^="LoadingOverlay-"]');
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        if (preventFocus) this.openedBy = null;
        super.hide();
        this.modalContent.innerHTML = '';
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        super.show(opener);
        this.enableLoading();
        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('[id^="MainProduct-"]');
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
            if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
            this.disableLoading();
            this.classList.add('has-content');
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
          });
      }

      hide() {
        super.hide();
        this.setInnerHTML(this.modalContent, '');
        this.classList.remove('has-content');
      }

      enableLoading() {
        this.loadingOverlay.enableLoading();
      }

      disableLoading() {
        this.loadingOverlay.disableLoading();
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }
    }
  );
}